import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class SetProductSwap extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        ImageInformation Web Service (Version 4)
                    </h1>
                    <div>
                        <h2 className="main-subheading">SetProductSwap</h2>
                        <div className="technical-main-content">
                            <p>The SetProductSwap method is typically used by the Service Aggregator/Subscriber to swap an image to
                        another product and in the meantime optionally changed the approval state of the image</p>
                            <h3>
                                WSDL URL</h3>
                            <p>
                                Thales will provide the WSDL URL for DevServer during the project.</p>
                            <br />
                            <h3>
                                Request Parameters</h3>
                            <ul>
                                <li><b>CardImageID</b> (string):
                                    <p>
                                    The unique identifier for the image being requested, This is generated by the Designer
                                    Website and passed to the Subscriber during the Handback procedure.</p> </li>
                                <li><b>ImageInformation_Key</b> (GUID):
                                    <p>
                                    This value identifies the caller and is matched to the Service Aggregator. This guarantees that the
                                    caller should have access to the requested CardImageID. Thales will provide the Aggregator with
                                the value for this parameter. Also note that a different value will be used on each environment.</p> </li>
                                <li><b>ProductHandover_Key</b> (GUID):
                                    <p>GUID that is used to load the AAM Designer which identifies the new product to switch to.</p> </li>
                                <li><b>TransactionApprovalState</b> (integer:optional):
                                    <p>States if a customer’s submission has been approved.</p> </li>
                                <li><b>Comment</b> (string:optional):
                                    <p>A comment about the transaction approval state.</p> </li>
                            </ul>
                            <br />
                            <h3>
                                Response Paramters</h3>
                            <ul>
                                <li><b>SetTransactionApprovalStateResponse</b> (integer): <br />
                                </li>
                                <li><b>SetProductSwapResult</b> (integer): <br />
                                </li>
                                <li><b>ErrorCode</b> (integer): <br />
                                    An error code describing the error (if any) that occurred during the method call.
                            </li>
                            </ul>
                            <br />
                            <h4>
                                Transaction Approval States</h4>
                            <ul>
                                <li><b>1 (Approved)</b>: the transaction for this image has been indicated as approved</li>
                                <li><b>2 (Not approved)</b>: the transaction for this image has been indicated as unapproved</li>
                            </ul>
                            <br />
                            <h3>
                                Error Codes</h3>
                            <ul>
                            <li><b>-2 (Unexpected system error)</b>:An internal error occurred. This indicates that the caller is not allowed to make a request due to IP transparency check.</li>
                                <li><b>-1 (Unexpected system error)</b>: An internal error occurred. The caller should
                                    attempt to call the method again. If a high number of such errors are encountered,
                                    the problem should be escalated to manual operators at Thales.</li>
                                <li><b>0 (Success)</b>: The method call was successful.</li>
                                <li><b>1 (CardImageID is invalid)</b>: The CardImageID isn’t a valid identifier.</li>
                                <li><b>2 (ImageInformation_Key is invalid or doesn’t match CardImageId)</b>: The CardImageID
                                    and ImageInformation_Key don’t match. This error will usually occur when an invalid
                                    or incorrect ImageInformation_Key is used.</li>
                                <li><b>3 (HandoverKeyInvalid is invalid)</b>: The Handover_Key inexisting in the system.</li>
                                <li><b>4 (TransactionApprovalState is invalid)</b>: The TransactionApprovalState isn’t
                                    of the value “1” or “2”.</li>
                            </ul>
                        </div>
                        <br />
                    <div className="document-content-back">
                        <Link className="document-content-link" to='/technical/imageinformation'>Back</Link>
                    </div>
                    <br />
                    <br />
                    <br />
                    </div>
                </div>
            </div>
        )
    }
}

export default SetProductSwap;